export default __webpack_public_path__ + "static/media/h5logo.2adda240.svg";